import parentRepository from './parentRepository'

export default {
  parent: parentRepository
}
